var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 39.2H1C0.447715 39.2 0 38.7523 0 38.2V1C0 0.447715 0.447717 0 1 0H38.2C38.7523 0 39.2 0.447717 39.2 1V38.2C39.2 38.7523 38.7523 39.2 38.2 39.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 98H1C0.447715 98 0 97.5523 0 97V59.8C0 59.2477 0.447717 58.8 1 58.8H38.2C38.7523 58.8 39.2 59.2477 39.2 59.8V97C39.2 97.5523 38.7523 98 38.2 98Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97 98H59.8C59.2477 98 58.8 97.5523 58.8 97V59.8C58.8 59.2477 59.2477 58.8 59.8 58.8H97C97.5523 58.8 98 59.2477 98 59.8V97C98 97.5523 97.5523 98 97 98Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39.2H59.8C59.2477 39.2 58.8 38.7523 58.8 38.2V1C58.8 0.447715 59.2477 0 59.8 0H97C97.5523 0 98 0.447717 98 1V38.2C98 38.7523 97.5523 39.2 97 39.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProperties);
export default __webpack_public_path__ + "static/media/iconProperties.2e55435bf3fbed08a70ba6a2fd936850.svg";
export { ForwardRef as ReactComponent };